<template>
 <lu-vbox class='app-container svpad-in-20' lu-flex>

    <Spinner ref='spinner' />

    <lu-item>
      <PageHeader :title='$t("Logo")' >
        <lu-hbox slot='extraArea' class='pad-in-5' >
            <template v-if="$acl.isAllowed('adminSettingEdit', isAdmin)">
              <lu-item><el-button class="button" icon="el-icon-edit" @click.stop='onSubmit' >{{ $t('Save') }}</el-button></lu-item>
            </template>
        </lu-hbox>
      </PageHeader>
    </lu-item>


    <lu-scroll-area lu-flex :scrollbarWidth='10' style='padding-right: 10px;'>
      <el-form ref='form' :model='form' label-width="180px">

        <lu-vbox lu-flex lu-flex-wrap class='sectionBox'>
          <PageTitle :title='$t("Login Logo")' :expanded='loginLogoExpanded'  />

          <lu-hbox v-if='loginLogoExpanded'>
            <el-form-item class='mar-l-10' prop='userLogo' style='max-width: 700px;' lu-flex-wrap v-if="$acl.isAllowed('adminSettingEdit', isAdmin)" >
              <el-upload
                  ref='uploadloginLogo'
                  :auto-upload="false"
                  action=""
                  v-model='form.loginLogo.data'
                  list-type="picture-card"
                  :on-preview="(file) => handlePreviewLogo('loginLogo', file)"
                  :on-remove="(file, list) => handleRemoveLogo('loginLogo', file, list)"
                  :on-change="(file, list) => changeLogo('loginLogo', file, list)"
                  :before-upload="(file, list) => beforeUploadLogo('loginLogo', file, list)"
                  accept=" .jpg, .jpeg, .png"
                  :limit=1
                  >
                    <i class="el-icon-plus"></i>
                    <div class="el-upload__tip" slot="tip">{{ $t('jpg/png files with a size less than 500kb') }}</div>
                </el-upload>

            </el-form-item>

            <lu-item lu-vcenter lu-hcenter v-if='form.loginLogo.data' class='logo' :style='loginLogoStyle' />

          </lu-hbox>
        </lu-vbox>

        <lu-vbox lu-flex lu-flex-wrap class='sectionBox'>
          <PageTitle :title='$t("Main Logo")' :expanded='mainLogoExpanded'  />

          <lu-hbox v-if='mainLogoExpanded'>
            <el-form-item class='mar-l-10' prop='userLogo' style='max-width: 500px;' lu-flex-wrap  v-if="$acl.isAllowed('adminSettingEdit', isAdmin)" >
              <el-upload
                  ref='uploadmainLogo'
                  :auto-upload="false"
                  action=""
                  v-model='form.mainLogo.data'
                  list-type="picture-card"
                  :on-preview="(file) => handlePreviewLogo('mainLogo', file)"
                  :on-remove="(file, list) => handleRemoveLogo('mainLogo', file, list)"
                  :on-change="(file, list) => changeLogo('mainLogo', file, list)"
                  :before-upload="(file, list) => beforeUploadLogo('mainLogo', file, list)"
                  accept=" .jpg, .jpeg, .png"
                  :limit=1
                  >
                    <i class="el-icon-plus"></i>
                    <div class="el-upload__tip" slot="tip">{{ $t('jpg/png files with a size less than 500kb') }}</div>
                </el-upload>

            </el-form-item>

            <lu-item lu-vcenter lu-hcenter v-if='form.mainLogo.data' class='logo' :style='mainLogoStyle' />

          </lu-hbox>
        </lu-vbox>


        <lu-vbox lu-flex lu-flex-wrap class='sectionBox'>
          <PageTitle :title='$t("Title Logo")' :expanded='titleLogoExpanded'  />

          <lu-hbox v-if='titleLogoExpanded'>
            <el-form-item class='mar-l-10' prop='userLogo' style='max-width: 500px;' lu-flex-wrap  v-if="$acl.isAllowed('adminSettingEdit', isAdmin)" >
              <el-upload
                  ref='uploadtitleLogo'
                  :auto-upload="false"
                  action=""
                  v-model='form.titleLogo.data'
                  list-type="picture-card"
                  :on-preview="(file) => handlePreviewLogo('titleLogo', file)"
                  :on-remove="(file, list) => handleRemoveLogo('titleLogo', file, list)"
                  :on-change="(file, list) => changeLogo('titleLogo', file, list)"
                  :before-upload="(file, list) => beforeUploadLogo('titleLogo', file, list)"
                  accept=" .jpg, .jpeg, .png"
                  :limit=1
                  >
                    <i class="el-icon-plus"></i>
                    <div class="el-upload__tip" slot="tip">{{ $t('jpg/png files with a size less than 500kb') }}</div>
                </el-upload>

            </el-form-item>

            <lu-item lu-vcenter lu-hcenter v-if='form.titleLogo.data' class='logo' :style='titleLogoStyle' />

          </lu-hbox>
        </lu-vbox>
      </el-form>

    </lu-scroll-area>
  </lu-vbox>
</template>

<script>
import BaseController from '@/controllers/BaseController'
import { LuHbox, LuVbox, LuScrollArea, LuItem } from 'lusis-ui'
import PageHeader from '@/components/PageHeader'
import PageTitle from '@/components/PageTitle'
import Spinner from '@/components/Spinner'

export default {
  name: 'adminSettings',
  extends: BaseController,
  components: { LuHbox, LuVbox, LuItem, LuScrollArea, PageTitle, PageHeader, Spinner },
  data () {
    return {
      loginLogoExpanded: true,
      mainLogoExpanded: true,
      titleLogoExpanded: true,
      loginLogoImageUrl: '',
      mainLogoImageUrl: '',
      titleLogoImageUrl: '',
      form: {
        'loginLogo': {
          configId: null,
          logoId: null,
          data: '',
          originData: '',
          name: 'loginLogo',
          value: '',
          description: ''
        },
        'mainLogo': {
          configId: null,
          logoId: null,
          data: '',
          originData: '',
          name: 'mainLogo',
          value: '',
          description: ''
        },
        'titleLogo': {
          configId: null,
          logoId: null,
          data: '',
          originData: '',
          name: 'titleLogo',
          value: '',
          description: ''
        }
      }
    }
  },
  created () {
  },
  asyncComputed: {
    configLogo: {
      get: function () {
        return this.$tango.searchConfig().then(rep => {
          if (rep.resultCode !== 0 || !rep.configList) {
            this.$message({
              message: this.$t('Error fetching config'),
              type: 'error'
            })
          }
          else {
            rep.configList.forEach(item => {
              this.form[item.name] = {
                configId: item.configId || null,
                logoId: item.logoId || null,
                data: item.data || null,
                originData: item.data || null,
                name: item.name || null,
                value: item.value || null,
                description: item.description || null
              }
            })
          }
        })
      },
      default: []
    }
  },
  computed: {
    loginLogoStyle() {
      return {
        'background-image': 'url(' + this.form.loginLogo.data + ')'
      }
    },
    mainLogoStyle() {
      return {
        'background-image': 'url(' + this.form.mainLogo.data + ')'
      }
    },
    titleLogoStyle() {
      return {
        'background-image': 'url(' + this.form.titleLogo.data + ')'
      }
    }
  },
  methods: {
    onSubmit() {
      this.$refs.spinner.show()
      let cond = {}
      cond.configList = []
      cond.configList.push(this.form.loginLogo)
      cond.configList.push(this.form.mainLogo)
      cond.configList.push(this.form.titleLogo)
      this.$tango.updateConfig(cond).then(rep => {
        if (rep.resultCode === 0) {
          this.$store.dispatch('user/setConfig', rep.configList)
        }
        this.$refs.spinner.hide()
      }).catch(err => {
        // eslint-disable-next-line no-console
        console.log(err)
      })
    },
    onCancel() {
      this.$message({
        message: 'cancel!',
        type: 'warning'
      })
    },
    checkLogo (file) {
      const isExceedLogoSize = file.size / 1024 / 1024 < 0.5 // 500k
      if (!isExceedLogoSize) {
        this.$message.error(this.$t('The file size exceeds the limit allowed 500kb'))
        return false
      }
      return true
    },
    changeLogo (type, file) {
      if (!this.checkLogo(file)) return false
      let self = this
      let reader = new FileReader()
      reader.readAsDataURL(file.raw)
      reader.onload = function () {
        self.form[type].data = this.result
      }
    },
    handlePreviewLogo () {
    },
    handleRemoveLogo (type) {
      this.$refs['upload' + type].clearFiles()
      this.form[type].data = this.form[type].originData
    },
    beforeUploadLogo (type, file) {
      if (!this.checkLogo(file)) return false
      let self = this
      let reader = new FileReader()
      reader.readAsDataURL(file.raw)
      reader.onload = function () {
        self.form[type].data = this.result
      }
    }
  }
}
</script>

<style scoped lang='scss'>
.logo {
  background: none no-repeat left;
  background-size: contain;
  height: 100px;
  width: 300px;
}
</style>

